export const preferenceKey = 'fraud-attacks-cookie-preferences';

export function excludedPath(path: string): boolean {
  return /^\/(backoffice|auth|([a-z]{2}\/)?kids)(\/|$)/i.test(path);
}

export function analyticsAllowed(production: boolean, hostname: string, hosts: string, path: string): boolean {
  return production && !excludedPath(path) && hosts.split(',').map(host => host.trim()).includes(hostname);
}

export function analyticsPath(path: string): string {
  return path.split(/[?#]/)[0]
    .replace(/^(\/admin\/rooms)\/[^/]+/, '$1/:id')
    .replace(/^(\/rooms|\/join|\/challenge|\/practice|\/groups)\/[^/]+/, '$1/:code');
}

export function analyticsConsent(value: string | null): boolean | null {
  try {
    const preferences = JSON.parse(value || 'null');
    return typeof preferences?.analytics === 'boolean' ? preferences.analytics : null;
  } catch { return null; }
}
